import { Select } from '@naf/input';
import styled from 'styled-components';
import { GridCol } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import { Link } from 'react-router-dom';
import { Button } from '@naf/button';

export const SelectGridCol = styled(GridCol)`
  margin-bottom: ${spacing.space8};
  margin-top: ${spacing.space32};
`;

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    gap: ${spacing.space12};
  }
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  height: ${spacing.space80};
  & > div {
    top: ${spacing.space80};
  }

  @media (max-width: ${breakpoints.m}) {
    height: 60px;
    & > div {
      top: 60px;
    }
  }
`;

export const StyledButtonLink = styled(Link)`
  & span {
    display: flex;
    justify-content: space-between;
    gap: ${spacing.space16};
  }

  & > div {
    white-space: nowrap;
    height: ${spacing.space80};

    @media (max-width: ${breakpoints.m}) {
      height: 60px;
      white-space: wrap;
    }
  }
`;

export const StyledButton = styled(Button)``;
